<div
  *ngIf="hasData"
  class="flex h-10 w-10 flex-shrink-0 items-center justify-center"
  [tp]="tooltipTemplate"
  [tpIsEnabled]="hasData"
  tpPlacement="top"
>
  <svg
    [attr.width]="24"
    [attr.height]="24"
    viewBox="0 0 22 22"
    fill="none"
    class="-rotate-90"
  >
    <circle
      cx="11"
      cy="11"
      [attr.r]="radius"
      stroke="#d1d5db"
      [attr.stroke-width]="strokeWidth"
      fill="none"
    />
    <circle
      cx="11"
      cy="11"
      [attr.r]="radius"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth"
      fill="none"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      class="text-m600 transition-[stroke-dashoffset] duration-300 ease-out"
    />
  </svg>
</div>

<ng-template #tooltipTemplate>
  <div class="grid grid-cols-[auto_auto] gap-x-3 gap-y-1 whitespace-nowrap">
    <div *ngIf="contextLimit">Usage</div>
    <div *ngIf="contextLimit" class="text-right font-semibold">
      {{ percentage }}%
    </div>
    <div>Tokens</div>
    <div class="text-right font-semibold">{{ totalFormatted }}</div>
    <div *ngIf="contextLimit">Limit</div>
    <div *ngIf="contextLimit" class="text-right font-semibold">
      {{ contextLimitFormatted }}
    </div>
  </div>
</ng-template>

<div *ngIf="contextUsage$ | async"></div>
